var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-10 w-100 d-flex justify-content-center"},[_c('b-spinner',{style:(_vm.style),attrs:{"variant":"primary","label":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }